/**
 * Single registration point for the post-process custom elements every product
 * viewport composes (`ssgi-postprocess`, `gtao-accumulate-postprocess`,
 * `outline-postprocess`, `sugar-taa`, `sugar-path-tracer`).
 *
 * These five imports used to be listed by hand in `SugarModelViewer.ts` and
 * `configurator/SugarConfigurator.ts`, so adding a pass meant editing every
 * product shell. Import this module instead:
 *
 *   import "../../platform/platform/viewport/registerPostProcessElements";   // eager
 *   import("../../platform/platform/viewport/registerPostProcessElements");  // lazy
 *
 * The element names must stay in sync with
 * `render/bindRenderSettingsHost.DEFAULT_RENDER_SETTINGS_WAIT_FOR`.
 */
import "../pipeline/elements/SSGIPostProcessElement";
import "../pipeline/elements/GTAOAccumulatePostProcessElement";
import "../pipeline/elements/OutlinePostProcessElement";
import "../pipeline/elements/SugarTAAPostProcessElement";
import "../pipeline/SugarPathTracer";

export const POST_PROCESS_ELEMENT_NAMES = [
  "ssgi-postprocess",
  "gtao-accumulate-postprocess",
  "outline-postprocess",
  "sugar-taa",
  "sugar-path-tracer",
] as const;
